import React, { useEffect } from 'react';
import './Projects.scss';
import ImageCard from './ImageCard';
import Carousel from './Carousel';
import projects from './projectsData';
import { Link } from 'react-router-dom';

// Reusable Projects section. When isStandalone=true, render page layout (breadcrumbs, full list).
const Projects = ({ isStandalone = false, showCarousel = false }) => {
    const displayedProjects = isStandalone ? projects : projects.slice(0, 3);

    useEffect(() => {
        document.title = isStandalone ? 'Projects – Kayleigh Schlupp' : 'Home – Kayleigh Schlupp';
    }, [isStandalone]);

    if (isStandalone) {
        return (
            <section id="projects" className="section-wrapper page">
                <div className="section-inner">
                    <nav aria-label="Breadcrumb" className="breadcrumbs">
                        <ol>
                            <li><Link to="/">Home</Link></li>
                            <li aria-current="page">Projects</li>
                        </ol>
                    </nav>
                    <h1 className="page-title">Projects</h1>
                    <p>A selection of recent work and side projects.</p>
                    <div className="projects-grid">
                        {displayedProjects.map((p) => (
                            <Link key={p.slug} to={`/projects/${p.slug}`}>
                                <ImageCard src={p.image} alt={`${p.title} preview`} caption={`${p.title}`} />
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        );
    }

    // Homepage projects section (dark card layout with border + carousel)
    return (
        <section id="projects" className="section-wrapper" aria-labelledby="projects-title">
            <div className="container border">
                <h1 id="projects-title" className="section-title">Projects</h1>
                <div className="projects-grid home-grid" data-count={displayedProjects.length}>
                    {displayedProjects.map((p) => (
                        <Link key={p.slug} to={`/projects/${p.slug}`}>
                            <ImageCard src={p.image} alt={`${p.title} preview`} caption={`${p.title}`} />
                        </Link>
                    ))}
                </div>
                <div className="projects-carousel">
                    <Carousel
                        items={projects.map((p) => ({
                            src: p.image,
                            alt: `${p.title} preview`,
                            caption: `${p.title}`,
                            slug: p.slug
                        }))}
                    />
                </div>
            </div>
        </section>
    );
};

export default Projects;
